import Accordion from "components/Accordion/Accordion";

import MinusIcon from "assets/icons/minus-gray.svg";
import PlusIcon from "assets/icons/plus-gray.svg";

import styles from "./expand-block.module.scss";

interface ExpandBlockInterface {
  title: string;
  children: any;
  isOpenDefault?: boolean;
  expandBlockId?: string;
}

const ExpandBlock = ({
  title,
  children,
  isOpenDefault,
  expandBlockId
}: ExpandBlockInterface) => {
  return (
    <Accordion
      accordionScrollWrapperId={`accordion-${expandBlockId}`}
      className={styles["expand-block-container"]}
      isOpenDefault={isOpenDefault}
      header={({ isOpen, onToggleAccordion }) => (
        <div
          id={expandBlockId}
          className={styles["expand-block-title-wrapper"]}
          onClick={onToggleAccordion}
        >
          <span className={styles["expand-block__title"]}>{title}</span>
          <span className={styles["expand-block__icon"]}>
            <img
              src={isOpen ? MinusIcon : PlusIcon}
              alt={`button ${isOpen ? "active" : "hidden"}`}
            />
          </span>
        </div>
      )}
    >
      {children}
    </Accordion>
  );
};

export default ExpandBlock;
